export const swapArrayEl = (array, swapIndex1, swapIndex2) => {
  const arrayCopy = array.slice();
  const temp = arrayCopy[swapIndex1];
  arrayCopy[swapIndex1] = arrayCopy[swapIndex2];
  arrayCopy[swapIndex2] = temp;
  return arrayCopy;
};
